import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AdminAuthService } from '../services/admin-auth.service';

/**
 * HTTP Interceptor that adds authentication token to all admin API requests
 * Excludes auth endpoints to prevent token errors during login/registration
 */
export const adminAuthInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AdminAuthService);
  const token = authService.token();

  // Skip adding auth header for auth endpoints
  const isAuthEndpoint = req.url.includes('/auth/login') ||
    req.url.includes('/auth/register') ||
    req.url.includes('/auth/me');

  // Debug: Log token status for non-auth requests
  if (!isAuthEndpoint) {
    console.log('[Interceptor]', req.method, req.url.split('/').slice(-2).join('/'), '| Token:', token ? 'present' : 'MISSING');
  }

  if (token && !isAuthEndpoint) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }

  return next(req);
};
